import { Timestamp } from 'firebase/firestore'
import { UserModelFactory } from 'monocle-models'
import type { z } from 'zod'

const { UserDBModel } = new UserModelFactory(Timestamp)

type User = z.infer<typeof UserDBModel>

export type AdminUserListItem = (
  | (User & {
      isCorrupt: false
      validationIssues?: never
    })
  | (Partial<User> & {
      id: string
      isCorrupt: true
      validationIssues: string[]
    })
) & {
  isAuthMissing?: boolean
}

const optionalString = (value: unknown) =>
  typeof value === 'string' ? value : undefined

export const parseAdminUserDocument = (
  id: string,
  rawData: Record<string, unknown>,
): AdminUserListItem => {
  const result = UserDBModel.safeParse({ ...rawData, id })

  if (result.success) {
    return {
      ...result.data,
      isCorrupt: false,
    }
  }

  return {
    id,
    name: optionalString(rawData.name),
    email: optionalString(rawData.email),
    isCorrupt: true,
    validationIssues: result.error.issues.map((issue) => {
      const path = issue.path.length > 0 ? issue.path.join('.') : 'document'
      return `${path}: ${issue.message}`
    }),
  }
}
